import { DataGrid } from '@mui/x-data-grid';
import { styled } from '@mui/material/styles';

/**
 * Styled DataGrid with consistent styling for use across the application
 * Used in admin pages and other data-heavy components
 */
const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  '& .MuiDataGrid-main': {
    backgroundColor: 'white'
  },
  '& .MuiDataGrid-row': {
    backgroundColor: 'white'
  },
  '& .child-row': {
    backgroundColor: theme.palette.grey[50]
  },
  '& .copy-trade-row': {
    backgroundColor: theme.palette.info.lighter
  },
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: theme.palette.grey[100]
  },
  '& .MuiDataGrid-footerContainer': {
    backgroundColor: 'transparent'
  },
  '& .MuiDataGrid-cell:focus': {
    outline: 'none !important'
  },
  '& .MuiDataGrid-cell:focus-within': {
    outline: 'none !important'
  },
  '& .MuiDataGrid-columnHeader:focus': {
    outline: 'none !important'
  },
  '& .MuiDataGrid-columnHeader:focus-within': {
    outline: 'none !important'
  },
  // Remove the cell selection outline
  '& .MuiDataGrid-cell.Mui-selected': {
    outline: 'none !important',
    border: 'none !important',
    backgroundColor: 'transparent !important'
  },
  '& .MuiDataGrid-cell.Mui-selected:focus': {
    outline: 'none !important',
    border: 'none !important',
    backgroundColor: 'transparent !important'
  }
}));

export default StyledDataGrid; 